import React from 'react';
import { motion } from 'framer-motion';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

/**
 * ═══════════════════════════════════════════════════════════════════════════
 * Oblique Design System — AutomationPanel
 * ═══════════════════════════════════════════════════════════════════════════
 */

const PANEL_VARIANTS = {
    initial: { opacity: 0, y: 6, scale: 0.97 },
    animate: { opacity: 1, y: 0, scale: 1 },
    exit:    { opacity: 0, y: 4, scale: 0.97 },
};
const PANEL_TRANSITION = { duration: 0.15, ease: [0.16, 1, 0.3, 1] };

export function AutomationPanel({ actions = [], onClose, onOpenBuilder }) {
    return (
        <motion.div
            variants={PANEL_VARIANTS}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={PANEL_TRANSITION}
            className="absolute top-[calc(100%+8px)] right-0 w-[280px] bg-[var(--bg-surface)] rounded-xl border border-[var(--border)] shadow-[0_12px_32px_rgba(0,0,0,0.15)] z-[2000] p-2.5 overflow-visible"
        >
            <div className="pt-2 px-3 pb-1">
                <button
                    onClick={(e) => { e.stopPropagation(); onClose(); onOpenBuilder(); }}
                    className="w-full flex items-center gap-2 py-1.5 px-2.5 bg-transparent border-none rounded cursor-pointer text-[var(--text-primary)] text-[13px] font-medium hover:bg-[var(--bg-subtle)] transition-colors duration-150"
                >
                    <ObliqueIcon name="add" size={16} color="var(--text-tertiary)" /> New automation
                </button>
            </div>
            <div className="flex flex-col p-1 border-t border-[var(--border-subtle)] mt-1">
                <div className="py-1 px-2 text-[11px] font-medium text-[var(--text-tertiary)]">Manual Actions</div>
                {actions.map((action, idx) => (
                    <motion.button
                        key={idx}
                        onClick={() => { action.onClick(); onClose(); }}
                        className="w-full flex items-center gap-2 py-1.5 px-2 rounded border-none bg-transparent cursor-pointer text-left hover:bg-[var(--bg-muted)] transition-colors duration-150"
                    >
                        <div className="text-[var(--text-tertiary)] flex items-center justify-center">
                            {action.icon || <ObliqueIcon name="flash_on" size={16} />}
                        </div>
                        <div className="flex-1">
                            <div className="text-[13px] text-[var(--text-primary)]">{action.label}</div>
                        </div>
                    </motion.button>
                ))}
            </div>
        </motion.div>
    );
}
